import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const PaymentFailed = () => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const onCloseHandler = () => {
		const redirectURL = sessionStorage.getItem('redirectURL');
		redirectURL
			? (navigate(redirectURL), sessionStorage.removeItem('redirectURL'))
			: navigate('/resume-templates');
	};
	return (
		<section className="payment-message d-flex align-items-center justify-content-center">
			<div className="payment-message-card bg-white w-100">
				<h2 className="fw-bold text-center mb-4 fail-msg">{translate('Common.paymentFailed')}</h2>
				<div className="payment-message-fail-detail text-center">
					<p className="mb-0">{translate('Common.paymentFailedPlesaeTryAgain')}</p>
				</div>
				<div className="text-center">
					<Button className="payment-message-btn filled border-0 text-white rounded-pill">
						{translate('Common.retry')}
					</Button>
					<Button className="payment-message-btn border rounded-pill" onClick={onCloseHandler}>
						{translate('Common.close')}
					</Button>
				</div>
			</div>
		</section>
	);
};

export default PaymentFailed;
